module.exports = __webpack_public_path__ + "static/media/HCMM172.af2e4bb0.jpg";